<template>
		<mobile v-if="$res.xsmall()" v-bind="props"/>
		<desktop v-else v-bind="props"/>
</template>

<script>
import {pick} from "lodash";
import desktop from "./desktop";
import mobile from "./mobile";

export default {
	components: {desktop, mobile},
	computed: {
		loaded: (t) => t.$store.getters["products/loaded"],
		categoryId: (t) => Number(t.$route.query.category_id),
		noItems: (t) => !t.groups.some(x => x.items.length),
		groups() {
			const groups = this.$store.getters["products/groups"];
			return groups.filter(x => this.categoryId ? x.id === this.categoryId : true);
		},

		props: (t) => pick(t, [
			"categoryId",
			"loaded"
		])
	}
};
</script>

<style lang="scss" scoped>
.products {
	margin-bottom: 4em;
}
</style>
